import { render, staticRenderFns } from "./BrandOverview.vue?vue&type=template&id=0b3f5a90&"
import script from "./BrandOverview.vue?vue&type=script&lang=js&"
export * from "./BrandOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports